// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3w41t","form":"styles_form__IIVQ7"};